import i18nReducers from './i18n';
import commonReducers from './common';
import logindReducers from './login';
import dashboardReducers from './dashboard';
import mapReducers from './map';
import maintenanceReducers from './maintenance';
import accountReducers from './account';
import cloudAccountReducers from './cloud-account';
import companyReducers from './company';
import menuReducers from './menu';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { USER_LOGOUT } from '../actions/login/index';

const appReducer = combineReducers({
  i18nReducers,
  commonReducers,
  logindReducers,
  menuReducers,
  dashboardReducers,
  mapReducers,
  maintenanceReducers,
  accountReducers,
  cloudAccountReducers,
  companyReducers,
  form: formReducer
})

const rootReducer = (state, action) => {
  if (action.type === USER_LOGOUT) {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer
